// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__FC9e7","cell":"ColumnAccessor_cell__3lcLc","firstCellAccent":"ColumnAccessor_firstCellAccent__3fBr0"};